import { useState } from 'react'

const useSort = (field, order) => {
  const [sortOrder, setSortOrder] = useState(order || 1)
  const [sortField, setSortField] = useState(field)

  const onSort = (e) => {
    setSortField(e.sortField)
    setSortOrder(e.sortOrder)
  }

  const sort = sortOrder === -1 ? '-' + sortField : sortField

  return {
    sortOrder,
    sortField,
    onSort,
    sort,
  }
}

export default useSort
